// Cards between two tall ads. A tall ad takes one extra cell per row it spans besides its own, so this
// is what brings the next one back to the first column: 11 ≡ -1 (mod 3 and mod 4) for the 2-row ad.
export const NEXT_PUBLI_POSITION = 11
// Experiment variant: the 3-row ad takes one more extra cell, so one card less keeps the next ad in the
// first column: 10 ≡ -2 (mod 3 and mod 4).
export const NEXT_PUBLI_POSITION_THREE_CARDS = 10
const MIN_CARDS_TO_SHOW_PUBLI = 10

export const MIN_COLUMNS_WITH_TALL_AD = 3

// The first tall ad takes the last cell of this row, so its 1-based grid position is
// `columns * FIRST_TALL_AD_ROW`: 4 columns → position 4, 3 columns → position 3.
// The rest of the tall ads are derived from the first, so moving this row moves all of them.
const FIRST_TALL_AD_ROW = 1

// getTallAdPositions takes the index of the card the ad is rendered AFTER, so the 1-based position
// above is shifted back by one for the index and by one more for that preceding card.
const TALL_AD_POSITION_TO_CARD_INDEX_OFFSET = 2

/**
 * Index of the card the first tall ad is rendered after. The ad starts on the first row and sits on
 * the right of the grid, spanning rows 1 & 2. Narrower grids hide it, so they keep the position the
 * minimum layout produces.
 */
export const getFirstTallAdPosition = ({columnsCount}) =>
  Math.max(columnsCount, MIN_COLUMNS_WITH_TALL_AD) * FIRST_TALL_AD_ROW - TALL_AD_POSITION_TO_CARD_INDEX_OFFSET

/**
 * Calculate tall ad positions based on number of columns in the grid layout
 * @param {number} totalCards - Total number of ad cards in the grid
 * @param {number} totalTallAds - Maximum number of tall ad positions to generate
 * @param {number} initialPosition - Initial position to show the 1st tall ad
 * @param {number} [nextPosition] - Cards between two tall ads
 * @returns {number[]} Array of indexes where tall ads should be inserted
 */
export const getTallAdPositions = (totalCards, totalTallAds, initialPosition, nextPosition = NEXT_PUBLI_POSITION) => {
  const positions = []
  let position = initialPosition

  while (position < totalCards && positions.length < totalTallAds) {
    positions.push(position)

    // increment +positions to show next tall ad
    position += nextPosition
  }

  // If we still need more tall ads and have cards left, add one at the end
  if (
    totalCards > 0 &&
    totalCards > MIN_CARDS_TO_SHOW_PUBLI &&
    !positions.includes(totalCards - 1) &&
    positions.length < totalTallAds
  ) {
    positions.push(totalCards - 1)
  }

  return positions
}
